import React from 'react';
import { MessageBox, MessageBoxProps } from 'components/_new/MessageBox';

type BlueProps = Omit<MessageBoxProps, 'title' | 'variant'>;

export const Blue = (props: BlueProps) => {
	return <MessageBox variant="blue" {...props} />;
};
